












































































































































































































































































































































































































































































































































































































































































import {Emit} from "vue-property-decorator";
import {Stored} from "vue-stored-prop-decorator";
import {Component} from '@/shared/component';
import {AbstractShowVue} from '@/components/Abstract/AbstractShowVue';
import {Achat, EssenceAchat, Token, User} from '@/models';

import storeAchat from '@/stores/modules/achat';
import storeToken from "@/stores/modules/token";
import storeEssenceAchat from "@/stores/modules/essenceAchat";

import CrudAddressShow from '@/components/Crud/Address/Show.vue';
import CrudEssenceAchatList from '@/components/Crud/EssenceAchat/ListEssenceAchat.vue';
import CrudDeleteDialog from '@/components/Crud/DeleteDialog.vue';
import CrudEssenceAchatEditDialog from '@/components/Crud/EssenceAchat/EditDialog.vue';
import CrudAchatEditGeneralDialog from "@/components/Crud/Achat/EditGeneralDialog.vue";
import Checked from "@/components/Checked.vue";
import CrudAchatEditDialogReglement from "@/components/Crud/Achat/EditDialogReglements.vue";
import CrudAchatEditDialogAchatFrais from "@/components/Crud/Achat/EditDialogAchatFrais.vue";
import CrudAchatEditSuiviDialog from "@/components/Crud/Achat/EditSuiviDialog.vue";
import CrudDocumentAchatUploader from "@/components/Crud/DocumentAchat/Uploader.vue";
import CrudDocumentAchatShow from "@/components/Crud/DocumentAchat/Show.vue";
import storeUser from "@/stores/modules/user";
import axios from "axios";

@Component({
	components: {
		CrudAddressShow,
		CrudAchatEditGeneralDialog,
		CrudAchatEditDialogReglement,
		CrudAchatEditSuiviDialog,
		CrudEssenceAchatList,
		CrudDeleteDialog,
		CrudEssenceAchatEditDialog,
		CrudDocumentAchatUploader,
		CrudDocumentAchatShow,
		CrudAchatEditDialogAchatFrais,
		Checked,
	}
})
export default class CrudAchatShow extends AbstractShowVue<Achat> {


	@Stored(() => storeUser) me!: User;

	private imgPath: string = "";

	private editAchat: Achat = null;
	private editSuivi: Achat = null;
	private editReglements: Achat = null;
	private editAchatFrais: Achat = null;
	
	private editEssenceAchat: EssenceAchat = null;
	private deletedEssenceAchat: EssenceAchat = null;

	@Stored(() => storeToken)
	private token: Token;

	private storeEssenceAchat = storeEssenceAchat;
	private dataFinance = null;

	public constructor() {
		super(storeAchat);
	}

	public async mounted(): Promise<void> {
		storeEssenceAchat.state.filters.clear();
		await super.mounted();

		this.loadFinancier();
	}

	public async loadFinancier(): Promise<void> {
		await axios.get(process.env.VUE_APP_BACK_BASE_URL + "/api/achats/financier/" + this.item.id + "?token=" + this.token.id, {}).then(async response => {
			this.dataFinance = await response.data;
		});
	}

	private get hrefPdf(): string {
		return `${process.env.VUE_APP_BACK_BASE_URL}/pdf/prestation_attestation/${this.item.id}?token=${this.token.id}`;
	}

	@Emit()
	private onCreateEssenceAchat(): void {
		this.editEssenceAchat = new EssenceAchat();
		this.editEssenceAchat.achat = this.item;
	}

	private async refreshAchat(): Promise<void> {
		this.loadFinancier();
		await this.refresh(this.value,true,true)
		this.$forceUpdate();
	}

	private async achatMarkPaid(achat: Achat): Promise<void> {
		await storeAchat.dispatch('putMarkPaid', achat);
		await storeAchat.dispatch('get', this.value.id);
	}

	private async achatFinCoupe(achat: Achat): Promise<void> {
		await storeAchat.dispatch('putFinCoupe', achat);
		await storeAchat.dispatch('get', this.value.id);
	}

}
